import React, {useState, useCallback, useEffect} from 'react';
import PulseLoader from 'react-spinners/PulseLoader'
import ethereum from 'decentralized/ethereum.js';
import ipfs from 'decentralized/Ipfs.js';
import {newEffectPreset, getEffectPresets} from 'decentralized/effects/EffectPresets.js';

export default ({effect, hide, sequencerEngine, trackNumber}) => {
    const [saveName, setSaveName] = useState('');
    const [presets, setPresets] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const savePreset = useCallback(() => {
        let json = effect.getJson();
        newEffectPreset(json, saveName);
        hide();
    }, [saveName, hide]);

    const loadPreset = useCallback(async (preset) => {
        setIsLoading(true);
        let json = await ipfs.getJson(preset.effectHash);
        await effect.fromJson(json, sequencerEngine.tracks, trackNumber, true, false);
        if (effect.track && effect.track.loadLostParameters) {
            effect.track.loadLostParameters();
        }
        setIsLoading(false);
        hide();
    }, [setIsLoading]);

    useEffect(() => {
        getEffectPresets(effect.name).then(
            p => setPresets(p));
    }, [setPresets]);

    let saveButtonClass = "save-button";
    if (saveName === '') {
        saveButtonClass += " disabled";
    }
    return (
        <div className="effect-presets">
          <PulseLoader
            sizeUnit={"px"}
            size={10}
            color={'#42f4f1'}
            loading={isLoading}
          />
          <div className="presets-container">
            {presets.map(
                preset => <Preset
                            id={preset.effectHash}
                            onClick={() => loadPreset(preset)}
                            preset={preset}/>)}
          </div>
          
          <div className="save-container">
            <input
              type="text"
              className="save-input"
              placeholder="Type name to save"
              value={saveName}
              onChange={(e) => setSaveName(e.target.value)}
            />
            <div
              onClick={savePreset}
              className={saveButtonClass}>
              SAVE
            </div>
          </div>
        </div>
    );
};

const Preset = ({preset, onClick}) => {
    const [author, setAuthor] = useState('');

    useEffect(() => {
        ethereum.users.getUserName(preset.user)
            .then(name => setAuthor(name));
    }, [setAuthor]);
    return (
        <div
          onClick={onClick}
          className="effect-preset">
          <div className="preset-title">
            {preset.title}
          </div>
          <div className="preset-author">
            {author}
          </div>
        </div>
    );
};
